module.exports = __webpack_public_path__ + "img/image05_sp.48c6aec5.jpg";